import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  heading: {
    fontFamily: 'Source Serif Pro',
    margin: 0,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
});
